"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_device_detect_1 = require("react-device-detect");
const webview_app_1 = require("@/webview_app");
function default_1() {
    const [appPushBlocked, setAppPushBlocked] = (0, react_1.useState)();
    const [androidChannelBlocked, setAndroidChannelBlocked] = (0, react_1.useState)();
    const [iosBannerBlocked, setIosBannerBlocked] = (0, react_1.useState)();
    const getPushPermission = () => {
        if (document.visibilityState === 'visible') {
            (0, webview_app_1.postMessageToWVA)('GETPUSHPERMISSION');
        }
    };
    const onPushPermissionMessage = (message) => {
        const { data } = message;
        if (String(data).startsWith('APPPUSH')) {
            const permissionObj = JSON.parse(data.split('::')[1]);
            if (permissionObj.appPush === 'ALLOW') {
                setAppPushBlocked(false);
                if (react_device_detect_1.isAndroid) {
                    setAndroidChannelBlocked(permissionObj.androidChannel === 'BLOCK');
                }
                else if (react_device_detect_1.isIOS) {
                    setAndroidChannelBlocked(false);
                    setIosBannerBlocked(permissionObj.iosBanner === 'BLOCK');
                }
            }
            else {
                setAppPushBlocked(true);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if (window.isNativeApp) {
            getPushPermission();
            window.addEventListener('message', onPushPermissionMessage);
            document.addEventListener('visibilitychange', getPushPermission);
            return () => {
                window.removeEventListener('message', onPushPermissionMessage);
                document.removeEventListener('visibilitychange', getPushPermission);
            };
        }
    }, []);
    return { appPushBlocked, androidChannelBlocked, iosBannerBlocked };
}
exports.default = default_1;
